var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfileIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2714.2 921.26c0 329.13-175.59 633.27-460.63 797.83-285.04 164.57-636.22 164.57-921.26 0-285.04-164.57-460.63-468.7-460.63-797.83 0-329.14 175.59-633.27 460.63-797.84 285.04-164.57 636.22-164.57 921.26 0 285.04 164.57 460.63 468.7 460.63 797.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1792.9 1984.3c907.09 0 1573.2 722.84 1573.2 1615.7h-3132.3c-14.172-892.91 666.14-1615.7 1559.1-1615.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon2);
export default __webpack_public_path__ + "static/media/userProfileIcon2.daa47c222e98389b3402e5517ad7318a.svg";
export { ForwardRef as ReactComponent };